module.exports = __webpack_public_path__ + "static/media/icon_nps.c4e28303.svg";